import { useId } from 'react';
import { IconPropsType } from '..';

export const PopularGamesColoredIcon = ({ ...props }: IconPropsType) => {
  const id = useId();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M16.6523 6.95833L13.4873 1.61806C13.3503 1.38715 13.0977 1.25 12.8817 1.25H5.06358C4.84751 1.25 4.62231 1.38715 4.48537 1.61667L1.34778 6.95694C1.15569 7.27976 1.18707 7.71111 1.421 7.99479L8.45394 16.5434C8.59375 16.7118 8.78547 16.8056 8.98633 16.8056C9.18718 16.8056 9.38012 16.7106 9.51798 16.5435L16.5783 7.9949C16.8136 7.71181 16.844 7.28125 16.6523 6.95833ZM12.836 3.49271L14.7715 6.80556H10.5079L12.836 3.49271ZM8.98633 6.35069L6.60042 2.91667H11.3692L8.98633 6.35069ZM5.13662 3.49271L7.43731 6.80556H3.17494L5.13662 3.49271ZM8.98633 14.7569L3.79516 8.47222H14.1787L8.98633 14.7569Z"
          fill={`url(#paint0_linear_1${id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_1${id}`}
          x1="9.00001"
          y1="1.25"
          x2="9.00001"
          y2="16.8056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E3E4" />
          <stop
            offset="0.464263"
            stopColor="#E2E3E4"
          />
          <stop
            offset="0.465549"
            stopColor="currentColor"
          />
          <stop
            offset="1"
            stopColor="currentColor"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
